import { useState, useCallback } from 'react'
import { Modal, Button, Alert, Toast } from "react-bootstrap"
import Form from 'react-bootstrap/Form';
import Confirm from '../../../../Components/Modals/Confirm';
import { SaveRevisionGarantiaDetalle } from '../../../../api/Api';
import { useGetUser } from "../../../../Hooks/CustomHooks";
import { captureRejectionSymbol } from 'events';

export default function CheckTesoreriaModal({ showModal,
    setShowModal,
    idDetalleGarantia,
    onSuccess,
    //validationTitle, 
    validationList,
    isAfterSave }) {

    const user = useGetUser()
    const [checkBoxAll, setCheckBoxAll] = useState(false);
    const [checkboxes, setCheckboxes] = useState({
        "31FDED0B-E887-4322-9D72-AAA6490A5647": false,
        "23946C07-4F96-4553-A4EA-1B8D1761069C": false,
        "D3FD44D0-79C2-48AF-8D5F-A0F1226E7664": false,
        "9AFBE02B-98DE-4A46-9787-FF580D4BCA70": false,
        "73F33A8D-DAB1-4D1D-85BC-062F17B3D92D": false,
        "EC144A78-63FD-4F29-895C-F1499D782672": false,
        "EC144A78-63FD-4F29-895C-F1499D782674": false
    });
    const checksTesoreriaGar1 = [
        { codigo: "31FDED0B-E887-4322-9D72-AAA6490A5647", nombre: "Error en el vencimiento" },
        { codigo: "23946C07-4F96-4553-A4EA-1B8D1761069C", nombre: "Error en el importe" },
        { codigo: "D3FD44D0-79C2-48AF-8D5F-A0F1226E7664", nombre: "Error en las condiciones" },
        { codigo: "9AFBE02B-98DE-4A46-9787-FF580D4BCA70", nombre: "Error en el beneficiario" },
        { codigo: "73F33A8D-DAB1-4D1D-85BC-062F17B3D92D", nombre: "Error en el emisor de valorado" },
        { codigo: "EC144A78-63FD-4F29-895C-F1499D782672", nombre: "Carta Fianza falsa" },
    ];

    const checksTesoreriaGar11 = {
        "31FDED0B-E887-4322-9D72-AAA6490A5647": "Error en el vencimiento",
        "23946C07-4F96-4553-A4EA-1B8D1761069C": "Error en el importe",
        "D3FD44D0-79C2-48AF-8D5F-A0F1226E7664": "Error en las condiciones",
        "9AFBE02B-98DE-4A46-9787-FF580D4BCA70": "Error en el beneficiario",
        "73F33A8D-DAB1-4D1D-85BC-062F17B3D92D": "Error en el emisor de valorado",
        "EC144A78-63FD-4F29-895C-F1499D782672": "Carta Fianza falsa",
        "EC144A78-63FD-4F29-895C-F1499D782674": "Envio correo de Validación"
    };

    const [showModalConfirm, setShowModalConfirm] = useState(false);

    const handleCheckboxChange = event => {
        setCheckBoxAll(false);
        console.info(event);

        const { name, checked } = event.target;
        console.info(event.target.name, "event.target.name");
        console.info(event.target.checked, "event.target.checked");
        setCheckboxes(prevState => ({
            ...prevState,
            [name]: checked
        }));
    };
    const handleCheckAll = event => {
        const { checked } = event.target;
        //Solo si marca la opcion
        setCheckBoxAll(checked);
        if (checked) {
            setCheckboxes(prevState => ({
                ...prevState,
                "31FDED0B-E887-4322-9D72-AAA6490A5647": !checked,
                "23946C07-4F96-4553-A4EA-1B8D1761069C": !checked,
                "D3FD44D0-79C2-48AF-8D5F-A0F1226E7664": !checked,
                "9AFBE02B-98DE-4A46-9787-FF580D4BCA70": !checked,
                "73F33A8D-DAB1-4D1D-85BC-062F17B3D92D": !checked,
                "EC144A78-63FD-4F29-895C-F1499D782672": !checked,
                "EC144A78-63FD-4F29-895C-F1499D782674": !checked,
            }));
        }

    };


    const handleClick = () => {

        // enviar `data` al servicio
        //console.log(data);
        //Oculta el Modal de Revision
        setShowModal(false);
        //Muestra el modal de Confirmacion
        setShowModalConfirm(true);
    };

    const saveRevision = useCallback(
        (idDetalleGarantia, revisiones, observaciones, rolRevisor, usuariorevisor) => {

            console.info(idDetalleGarantia, "idDetalleGarantia");
            console.info(revisiones, "revisionesssssss")
            SaveRevisionGarantiaDetalle(idDetalleGarantia, revisiones, observaciones, rolRevisor, usuariorevisor).then((response) => {
                onSuccess && onSuccess();
                setShowModal(false);
                console.info("Ok!!!!!!")
            })
        }, [idDetalleGarantia]
    )


    // Cierre del Modal
    const onCloseModalConfirm = () => {
        setShowModal(true);
    }

    //Confirmacion del Modal
    const onConfirmModalConfirm = () => {

        const revisiones = Object.entries(checkboxes).map(([key, value]) => ({ [key]: value }));
        const revisionesObject = revisiones.reduce((obj, item) => {
            const key = Object.keys(item)[0];
            obj[key] = item[key];
            return obj;
        }, {});

        // console.info(datax, "datax");
        //console.info(revisionesx, "revisionesx");




        var item = `<form class=''>`
        Object.entries(checkboxes).forEach(([key, value]) => {
            item = item + `<div class='py-3 form-check'>`
            item = item + `<input type='checkbox' class='form-check-input' ${value ? "checked='true'" : ""} />`
            item = item + `<label title='' class='form-check-label'>${checksTesoreriaGar11[key]}</label>`
            item = item + `</div>`
            //item = item + `<li><i class="fi fi-rr-checkbox"></i> ${checksTesoreriaGar11[key]} </li>`;
        })
        var item = item + `</form>`
        console.info(item);
        saveRevision(idDetalleGarantia, revisionesObject, item, user.role.id, user.email);

    }

    const isNoneCheckSelected = () => {
        return Object.values(checkboxes).every(checked => !checked) && !checkBoxAll;
    }

    return (
        <>
            <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static" keyboard={false} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header >
                    <Modal.Title>Revisión de Garantía para aprobación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert key='info' variant='info'>
                        <b>INFORMACION</b>: Revise cuidadosamente los datos registrados en la Garantía yseleccione cuidadosamente las opciones que usted crea conveniente antes de <b><u>guardar</u></b> la revisión.
                    </Alert>
                    {isNoneCheckSelected() &&
                        <Alert key='warning' variant='warning'>
                            <b>ADVERTENCIA</b>: Marque al menos una de las opciones presentadas para poder <b><u>guardar</u></b> la revisión.
                        </Alert>
                    }

                    <Form>
                        <Form.Check

                            type="checkbox"
                            label='Toda la informacion es correcta.'
                            name='check_all'
                            checked={checkBoxAll}
                            onChange={handleCheckAll}
                            className='py-3'
                        />
                        {/* {checksTesoreriaGar1.map(item => (
                            <Form.Check
                                key={item.codigo}
                                type="checkbox"
                                label={item.nombre}
                                name={item.codigo}
                                checked={checkboxes[item.codigo]}
                                onChange={handleCheckboxChange}
                                className='py-3'
                            />
                        ))} */}

                        {Object.entries(checksTesoreriaGar11).map(([key, value]) => (
                            <Form.Check
                                key={key}
                                type="checkbox"
                                label={value}
                                name={key}
                                checked={checkboxes[key]}
                                onChange={handleCheckboxChange}
                                className='py-3'
                            />
                        ))}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secundary"
                        onClick={() => setShowModal(false)}

                    >Cerrar</Button>
                    <Button
                        variant="primary"
                        onClick={handleClick}
                        disabled={isNoneCheckSelected()}
                    >Guardar</Button>
                </Modal.Footer>
            </Modal>

            <Confirm
                showModal={showModalConfirm}
                setShowModal={setShowModalConfirm}
                onClose={onCloseModalConfirm}
                onConfirm={onConfirmModalConfirm}
                message={'Seguro que desea <b><u>confirmar</u></b> la revision de la Garantía?'}
            />

        </>


    )
}